module.exports = __webpack_public_path__ + "static/img/makenew.417d315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/makeAppointment/makenew.png
// module id = +CF5
// module chunks = 33